import validate from './RegistrationEntryFormValidation';

import UseForm from "@usas/ui-web/utils/UseForm";

const INITIAL_FORM_STATE = {
  entityName: '',
  tradeName: '',
  taxId: ''
};

const useRegistrationEntryForm = (onSubmitFormCallback) => {
  const { formState, errorState, handleSubmit, updateFormState
  } = UseForm(INITIAL_FORM_STATE, onSubmitFormCallback, validate);

  return {
    formState,
    errorState,
    handleSubmit,
    updateFormState
  };
};

export default useRegistrationEntryForm;